"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebConsole = void 0;
class WebConsole {
    constructor() {
        this.defaultStyle = "padding: 2px 4px;";
    }
    log(time, loglevel, tag, tagConfigs, ...args) {
        console.log(`${time} %c${loglevel}: %c${tag}`, this.getLogLevelStyles(tagConfigs), this.getTagStyles(tagConfigs), ...args);
    }
    getLogLevelStyles(tagConfigs) {
        return `background-color: ${tagConfigs.backgroundColor};
    color: ${tagConfigs.color};
    font-weight: bold;
    ${this.defaultStyle}
   `;
    }
    getTagStyles(tagConfigs) {
        return `background-color: ${tagConfigs.backgroundColor}55;
    color: black;
    font-weight: normal;
    ${this.defaultStyle}
   `;
    }
}
exports.WebConsole = WebConsole;
